<template>
  <div class="sign_view">
    <div class="query_wapper">
      <div class="query_item">
        <el-button-group>
          <el-button
            @click="selectType(1)"
            :class="switchType === 1?'select':'normal'"
            style="width:100px"
          >报名表</el-button>
          <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
        </el-button-group>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          style="width:150px"
          v-model="query.year"
          @change="selectYear"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          v-model="query.matchId"
          @change="selectMatch"
          style="width:200px;"
          placeholder="请选择赛事"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          v-model="query.id"
          placeholder="请选择学校"
          style="width:200px;"
          @change="getSignDetail"
        >
          <el-option
            v-for="(item,index) in schoolList"
            :key="index"
            :value="item.id"
            :label="item.schoolName"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" v-if="userInfo.project !== 9" style="flex:1;">
        <el-button type="warning" style="width:90px;margin-right:8px;" @click="print">打印</el-button>
        <!-- <el-button type="primary" style="width:90px" v-if="!isOtherBall" @click="exportPdf">导出</el-button> -->
      </div>
      <div class="query_item">
        <el-button style="width:90px" type="primary" @click="moveBack">返回</el-button>
      </div>
    </div>
    <div v-if="switchType === 1" class="table_box">
      <p class="head_title">单位名称：{{getSchoolName}}</p>
      <p class="head_title" style="margin:10px 0;">领队：{{details.leaderName}}</p>
      <p class="head_title">教练：{{getCoachName}}</p>
      <table
        style="border:1px solid #ddd;margin-top:20px"
        border="0"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <template v-for="(item,index) in columns">
             <!-- && item.key !== 'ws4' && item.key !== 'ws5' && item.key !== 'ws6' && item.key !== 'ws7' && item.key !== 'ws8' -->
            <th
              v-if="item.key !== 'ws1' && item.key !== 'ws2' && item.key !== 'ws3'"
              :key="index"
              :style="{width:item.width + 'px'}"
              class="ths big_title"
            >
              <div class="cell">{{item.title}}</div>
            </th>
            <th
              class="ths"
              v-else-if="item.key == 'ws1'"
              :key="index"
              :style="{width:item.width + 'px'}"
            >
              <span class="big_title">自选拳术（单项）</span>
              <!-- <span class="small_title">（单项）</span> -->
            </th>
            <th
              class="ths"
              v-else-if="item.key == 'ws2'"
              :key="index"
              :style="{width:item.width + 'px'}"
            >
              <span class="big_title">自选短器械（单项）</span>
              <!-- <span class="small_title">（单项）</span> -->
            </th>
            <th
              class="ths"
              v-else-if="item.key == 'ws3'"
              :key="index"
              :style="{width:item.width + 'px'}"
            >
              <span class="big_title">自选长器械（单项）</span>
              <!-- <span class="small_title">（单项）</span> -->
            </th>
            <!-- <th
              class="ths"
              v-else-if="item.key == 'ws4'"
              :key="index"
              :style="{width:item.width + 'px'}"
            >
              <span class="big_title">42式太极剑</span>
              <span class="small_title">（单项）</span>
            </th>
            <template v-else-if="item.key == 'ws5'">
              <th class="ths" :key="index" :style="{width:item.width + 'px'}">
                <p>
                  <span class="big_title">其他拳术</span>
                  <span class="small_title">（单项）</span>
                </p>
                <span class="small_title">（备注项目）</span>
              </th>
            </template>
            <template v-else-if="item.key == 'ws6'">
              <th class="ths" :key="index" :style="{width:item.width + 'px'}">
                <p>
                  <span class="big_title">其他器械</span>
                  <span class="small_title">（单项）</span>
                </p>
                <span class="small_title">（备注项目）</span>
              </th>
            </template>
            <th
              class="ths"
              v-else-if="item.key == 'ws7'"
              :key="index"
              :style="{width:item.width + 'px'}"
            >
              <p class="big_title">品势：单人</p>
              <span class="small_title">（单项）</span>
            </th>
            <th
              class="ths"
              v-else-if="item.key == 'ws8'"
              :key="index"
              :style="{width:item.width + 'px'}"
            >
              <p class="big_title">品势：团体</p>
              <span class="small_title">（多人）</span>
            </th> -->
          </template>
        </thead>
        <tbody>
          <tr v-for="(item,index) in details.athleteList" :key=" index">
            <td style="text-align:center;color:#444;">
              <div class="cell">{{index + 1}}</div>
            </td>
            <template v-for="(temp,num) in columns.slice(1)">
              <td style="text-align:center;color:#444;" :key="num + '_' + index">
                <div class="cell">{{getKey(temp.key,index)}}</div>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <template v-if="details.matchName">
        <div
          v-if="details.state === 0"
          style="height:100px;color:#444;padding:20px;border:1px solid #ddd;border-top:none"
        >
          <section
            style="display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
          >
            <p style="font-size:24px">报名未提交</p>
          </section>
        </div>
        <div
          v-else
          :style="{height:details.state == 2 && userInfo.type === 4?'150px':'100px'}"
          style="width:100%;color:#444;padding:10px 20px;border:1px solid #ddd;border-top:none"
        >
          <p style="font-size:14px;">体育部意见：</p>
          <p
            style="font-size:24px;text-align:center;margin-top:10px;"
          >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>
        </div>
      </template>
      <template v-else>
        <div class="table_list">
          <div style="height:100px;color:#444;padding:20px;border:1px solid #ddd;border-top:none">
            <section
              style="font-size:24px;display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
            >
              <p>暂无数据</p>
            </section>
          </div>
        </div>
      </template>
    </div>
    <athletePhoto v-else :details="details"></athletePhoto>
    <div id="prints">
      <div style="page-break-after:always;">
        <h2 class="match_title">{{getMatchName}}</h2>
        <p class="head_title">单位名称：{{getSchoolName}}</p>
        <p class="head_title distance" style="margin:10px 0;">领队：{{details.leaderName}}</p>
        <p class="head_title">教练：{{getCoachName}}</p>
        <table
          v-for="t in getTableNum"
          :style="{marginTop:t!== 1?'80px':''}"
          style="border:1px solid #ddd;margin-top:20px;width:100%;page-break-after:always"
          border="0"
          :key="t"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <template v-for="(item,index) in columns">
               <!-- && item.key !== 'ws4' && item.key !== 'ws5' && item.key !== 'ws6' && item.key !== 'ws7' && item.key !== 'ws8' -->
              <th
                v-if="item.key !== 'ws1' && item.key !== 'ws2' && item.key !== 'ws3'"
                :key="index"
                :style="{width:item.width + 'px',borderRight:index == columns.length - 1?'none!important':'1px solid #999'}"
                class="ths big_title"
              >
                <div class="cell">{{item.title}}</div>
              </th>
              <th class="ths" v-else-if="item.key == 'ws1'" :key="index" style="width:90px">
                <p class="big_title">自选拳术</p>
                <span class="small_title">（单项）</span>
              </th>
              <th class="ths" v-else-if="item.key == 'ws2'" :key="index" style="width:90px">
                <p class="big_title">自选短器械</p>
                <span class="small_title">（单项）</span>
              </th>
              <th class="ths" v-else-if="item.key == 'ws3'" :key="index" style="width:90px">
                <p class="big_title">自选长器械</p>
                <span class="small_title">（单项）</span>
              </th>
              <!-- <th class="ths" v-else-if="item.key == 'ws4'" :key="index" style="width:90px">
                <p class="big_title">42式太极剑</p>
                <span class="small_title">（单项）</span>
              </th>
              <template v-else-if="item.key == 'ws5'">
                <th class="ths" :key="index" style="width:110px">
                  <p>
                    <span class="big_title">其他拳术</span>
                    <span class="small_title">（单项）</span>
                  </p>
                  <span class="small_title">（备注项目）</span>
                </th>
              </template>
              <template v-else-if="item.key == 'ws6'">
                <th class="ths" :key="index" style="width:110px">
                  <p>
                    <span class="big_title">其他器械</span>
                    <span class="small_title">（单项）</span>
                  </p>
                  <span class="small_title">（备注项目）</span>
                </th>
              </template>
              <th class="ths" v-else-if="item.key == 'ws7'" :key="index" style="width:90px">
                <p class="big_title">品势：单人</p>
                <span class="small_title">（单项）</span>
              </th>
              <th class="ths" v-else-if="item.key == 'ws8'" :key="index" style="width:90px">
                <p class="big_title">品势：团体</p>
                <span class="small_title">（多人）</span>
              </th> -->
            </template>
          </thead>
          <tbody>
            <tr v-for="(item,index) in details.athleteList.slice((t -1) * 18,t* 18)" :key=" index">
              <td style="text-align:center;color:#444;border-right:1px solid #999">
                <div class="cell">{{index + 1}}</div>
              </td>
              <template v-for="(temp,num) in columns.slice(1)">
                <td
                  :style="{borderRight:num == columns.length - 2?'none!important':'1px solid #999'}"
                  style="text-align:center;color:#444;"
                  :key="num + '_' + index"
                >
                  <div class="cell">{{getKey(temp.key,index)}}</div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <athletePhoto :details="details"></athletePhoto>
    </div>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage";
import { signDetail, signList } from "@/api/sign-up-match";
import { method } from "@/utils/utils";
import athletePhoto from "../../martial/components/athletes-photo";
import { getMatchList } from "@/api/sports-management";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { message, selectiveYear } from "@/common/js/mixins";
import { getCoachList } from "@/api/athletes.js";
export default {
  // 报名表查看
  components: {
    athletePhoto
  },
  mixins: [message, selectiveYear],
  props: {
    info: {
      type: Object
    },
    isListPrint: {
      type: Boolean
    }
  },
  data() {
    return {
      isShowBottom: true,
      loading: null,
      isShowBorder: true,
      isRender: false,
      matchList: [],
      switchType: 1,
      matchName: "",
      schoolList: [],
      coachList: [],
      details: {},
      tableData: {},
      userInfo: JSON.parse(getSession("userInfo")) || "",
      query: {
        year: "",
        id: "",
        matchId: ""
      },
      columns: [
        {
          title: "序号",
          width: 60
        },
        {
          title: "组别",
          width: 80,
          key: "groupId"
        },
        {
          title: "性别",
          width: 80,
          key: "genderText"
        },
        {
          title: "姓名",
          width: 140,
          key: "athleteName"
        },
        {
          title: "身份证号码",
          width: 200,
          key: "idCard"
        },
        {
          title: "",
          width: 160,
          key: "ws1"
        },
        {
          title: "",
          width: 160,
          key: "ws2"
        },
        {
          title: "",
          width: 160,
          key: "ws3"
        },
        // {
        //   title: "",
        //   width: 140,
        //   key: "ws4"
        // },
        // {
        //   title: "",
        //   width: 140,
        //   key: "ws5"
        // },
        // {
        //   title: "",
        //   width: 140,
        //   key: "ws6"
        // },
        // {
        //   title: "",
        //   width: 100,
        //   key: "ws7"
        // },
        // {
        //   title: "",
        //   width: 100,
        //   key: "ws8"
        // },
        {
          title: "备注",
          key: "remarks",
          width: 140
        }
      ]
    };
  },
  computed: {
    getTableNum() {
      const length = this.details.athleteList
        ? this.details.athleteList.length
        : 0;
      let num = 0;
      if (length > 18) {
        if (parseFloat(length / 18) > parseInt(length / 18)) {
          num = parseInt(length / 18) + 1;
        } else num = parseInt(length / 18);
      } else if (length > 0 && length <= 18) {
        num = 1;
      }
      return num;
    },
    getCoachName() {
      let coach = this.details.coachIds ? this.details.coachIds.split(",") : [];
      let arr = [];
      this.coachList.filter(item => {
        if (coach.includes(item.id)) {
          arr.push(item.name);
        }
      });
      return arr.join(",");
    },
    // 获取学校名称
    getSchoolName() {
      let str = "";
      this.schoolList.filter(item => {
        if (item.id === this.query.id) str = item.schoolName;
      });
      return str;
    },
    // 获取赛事名称
    getMatchName() {
      let str = "";
      this.matchList.filter(item => {
        if (item.id === this.query.matchId) {
          str = item.name;
          this.matchName = item.name;
        }
      });
      return str;
    },
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    },
    getKey() {
      return (key, index) => {
        let keys = "";
        this.columns.filter(item => {
          if (item.key === key) {
            switch (key) {
              case "ws1":
                keys = this.details.athleteList[index].projectJson[item.key];
                break;
              case "ws2":
                keys = this.details.athleteList[index].projectJson[item.key];
                break;
              case "ws3":
                keys = this.details.athleteList[index].projectJson[item.key];
                break;
              // case "ws4":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              // case "ws5":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              // case "ws6":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              // case "ws7":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              // case "ws8":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              case "groupId":
                keys =
                  this.details.athleteList[index][item.key] == 1
                    ? "甲组"
                    : this.details.athleteList[index][item.key] == 2
                    ? "乙组"
                    : this.details.athleteList[index][item.key] == 4
                    ? "丙组"
                    : "丁组";
                break;
              default:
                keys = this.details.athleteList[index][item.key];
                break;
            }
          }
        });
        return keys;
      };
    }
  },
  watch: {
    info: {
      handler(value) {
        if (value) {
          this.switchType = 1;
          Object.assign(this.query, {
            year: value.year,
            matchId: value.matchId,
            id: value.id
          });
          this.getMatch();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
        })
        .catch(err => {});
    },
    // 打印
    print() {
      if (this.schoolList.length === 0) {
        return this.openWarn("当前赛事暂无数据打印");
      }
      this.$nextTick(() => {
        this.isShowBottom = true;
        var el = document.querySelector("#prints"),
          iframe = document.createElement("IFRAME"),
          doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(
          '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 5mm;} .athlete_name {font-size:14px!important} .athlete_regist_number{font-size:12px!important } .border_bottom {border-bottom:1px solid #999!important} .border_top {border-top:1px solid #999!important} .border_right {border-right:1px solid #999!important} .border_left {border-left:1px solid #999!important} .margin_top {margin-top:20mm!important} .match_title {margin:10mm 0 20px;text-align:center;font-size:22px;font-family:PF;font-weight:bold;} .athletes_photo header h2 {margin:0;padding:0} .athletes_photo header h1 {font-size:24px;margin:0 0 14px} .athletes_photo {margin:10px 0 0 0!important} .athletes_photo header {text-align: center;padding: 44px 0;margin:0;color: #444;font-weight: 600;} .big_title {font-size: 14px;}.small_title {font-size: 12px;} table {border:1px solid #999!important} table thead .ths p {margin:0;padding:0} table thead .ths {height: 40px;box-sizing: border-box;vertical-align: middle;font-size:14px!important;border-right:2px solid #999} table tbody td .cell {color:#000} table tbody td {padding: 8px 2px;font-size: 13px;vertical-align: middle;border-top: 1px solid #999;border-right:1px solid #999} .head_title {font-size: 18px;color: #444;font-family: pfSem;padding:0;margin:0;} .fonts_color {color:#000} .athlete_infos {padding:10px 5px!important} .info_text {word-break:break-all} .page_break {margin-top:15mm!important} .phones {width:230px!important} .info_row {margin:0 0 15px 0} .foots {margin-top:20px} .info {margin-bottom:20px} table {margin-top:20px}  main {margin:15mm 0} h1 { margin:5mm 0 40px 0;font-size:24px;text-align:center } span.rights {width:560px}</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );
        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        };
      });
    },
    // 返回上级
    moveBack() {
      Object.assign(this.query, this.$options.data().query);
      this.$emit("backs");
    },
    // 切换按钮组
    selectType(switchType) {
      this.switchType = switchType;
    },
    // 选择年份
    selectYear() {
      this.query.matchId = "";
      this.query.id = "";
      this.matchList = [];
      this.schoolList = [];
      this.details = {};
      this.tableData = {};
      this.getMatch();
    },
    // 获取赛事
    getMatch() {
      getMatchList({
        project: this.userInfo.project,
        year: this.query.year,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = [];
          if (res.list.length > 0) {
            this.matchList = res.list;
          }
          this.getList();
        })
        .catch(err => {});
    },
    // 选择赛事
    selectMatch(value) {
      this.query.id = "";
      this.schoolList = [];
      this.details = {};
      this.tableData = {};
      this.matchList.filter(item => {
        if (item.id === value) {
          this.matchName = item.name;
        }
      });
      this.getList();
    },
    // 获取详情数据
    getSignDetail(id = this.query.id) {
      signDetail({ id })
        .then(res => {
          this.details = res;
          this.selectType(this.switchType);
          this.tableData = JSON.parse(JSON.stringify(res.swimAthleteList));
          this.isRender = true;
        })
        .catch(err => {});
    },
    // 列表数据
    getList() {
      signList({
        ...this.query,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.schoolList = res.list;
          if (this.query.id) this.getSignDetail(this.query.id);
          else {
            if (res.list.length > 0 && this.query.matchId) {
              this.query.id = res.list[0].id;
              this.getSignDetail(this.query.id);
            }
          }
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getCoachLists();
    this.getYearLists(this.query);
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/font/pfSembold.css";
.big_title {
  font-size: 15px;
}
.small_title {
  font-size: 12px;
}
.head_title {
  font-size: 18px;
  color: #444;
  font-family: pfSem;
}
.select {
  background: #1e63b0;
  color: #fff;
}
.normal {
  background: transparent;
  color: #999;
}
table {
  thead {
    .ths {
      background: #eee;
      height: 40px;
      box-sizing: border-box;
      vertical-align: middle;
      &:not(:last-of-type) {
        border-right: 1px solid #ddd;
      }
    }
  }
  tbody {
    td {
      padding: 8px 2px;
      font-size: 14px;
      vertical-align: middle;
      border-top: 1px solid #ddd;
      &:not(:last-of-type) {
        border-right: 1px solid #ddd;
      }
    }
  }
}
#prints {
  position: absolute;
  left: -100000px;
  top: -100000px;
  opacity: 0;
}
</style>